import { CONSTANTS } from '@pk/powerkioskutils';

import { Contract } from './contract';

export class NewDashboardContractsGridCriteria {
	public searchContractIds?: string;
	public status?: string;
	public contractNum?: string;
	public isLayeredPurchasing?: boolean;
	public serviceTypeId?: string;
	public isResidential?: boolean;
	public selectedRenewalMonth?: string;
	public filteredContractIds?: string;

	constructor(newDashboardContractsGridCriteria?: NewDashboardContractsGridCriteria) {
		Object.assign(this, newDashboardContractsGridCriteria);
	}
}

export class NewDashboardContractGridRow extends Contract {
	public customerName?: string;
	public usage?: string;
	public ptc?: number;
	public minRate?: number;
	public isLayeredPurchasing?: boolean;

	constructor(newDashboardContractGridRow?: NewDashboardContractGridRow) {
		super(newDashboardContractGridRow);
	}

	get showHoldSubmissionStatus(): boolean {
		return this.displayStatus === 'Signed' && this.submissionStatus === CONSTANTS.submissionStatus.onHold;
	}

	get showAutoSubmissionStatus(): boolean {
		return (
			this.displayStatus === 'Signed' && this.submissionStatus === CONSTANTS.submissionStatus.submitted && !!this.submissionStatusAutoSubmittedDate
		);
	}
}

export class NewDashboardContractsGrid {
	public message?: NewDashboardContractGridRow[];
	public start?: number;
	public end?: number;
	public total?: number;

	constructor(newDashboardContractsGrid?: NewDashboardContractsGrid) {
		Object.assign(this, newDashboardContractsGrid);
	}
}
